import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ShimmerCategoryList } from "react-shimmer-effects";
import { breadcrumb, enrollModal, selectType, showModal } from "../../redux/actions";
import { getCourseActivityData, getLifePlan, getPlanSchedule, getUserPlan, postCoursesHcfPlan } from "../../redux/actions/APIs";
import { convertedNumber, datesorting, getAlluserCourses, getCapitalized, getName, getProfileName, getSequnceSort, textTrim } from "../../utils/helper";
import MainLayOut from "../MainLayOut/MainLayOut";
import MyPlanHeader from "./MyPlanHeader";
import MyPlanRightPanel from "./MyPlanRightPanel";
import PlanCards from "./PlanCards";
import SearchModule from "./SearchModule";

const MyPlanPage = () => {

	const location = useLocation();
	const dispatch = useDispatch();
	const history = useHistory();
	const params = useParams();

	const {
		loggedInUser,
		defaultChildData,
		getUserPLanResp,
		courseActivitData,
		courseBadgesData,
		courseshcfData,
		courseEnrollResponse

	} = useSelector((state) => state.collections);

	const [planIndex, setPlanIndex] = useState(0);
	const [selectedCourse, setSelectedCourse] = useState();
	const [planBadgesCourse, setPlanBadgesCurse] = useState([]);
	const [getAllPlan, setAllPlan] = useState([]);
	const [isViewPlan, setIsViewPlan] = useState(false);
	const [selectChild, setSelectChild] = useState();
	const [seacrhText, setSearchText] = useState("")
	const [searchType, setSearchType] = useState("");


 useEffect(() => {
		if (location?.state?.isCouponPopUp) {
			if (loggedInUser?.role?.name === "PARENT") {
				dispatch(showModal({ type: "DimensionHintPopup" }));
				history.replace({ ...history.location, state: {} });
			}
		}
	}, [location, loggedInUser])

	useEffect(() => {
		if (loggedInUser?.children?.length > 0) {
			setSelectChild(datesorting(loggedInUser?.children)[0]);
		} else if (loggedInUser) {
			setSelectChild(loggedInUser);
		}
	}, [loggedInUser])

	// console.log("MyPlanPage : ",location ,getUserPLanResp, selectedCourse, courseActivitData);

	// console.log("MyPlanPage : ",location ,getUserPLanResp, courseshcfData, getAllPlan, getAlluserCourses(getAllPlan[0])[0], getAlluserCourses(getAllPlan[1])[0] );

	useEffect(() => {
		dispatch(breadcrumb({ title: "🚀 My Plans" }));
		if (selectChild) {
			let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : selectChild?.id;
			dispatch(getUserPlan(userId, selectChild?.id))
			if (location?.state?.type === "LifeEvent") {
				dispatch(getLifePlan(selectChild?.id, location?.state?.getCourseIds));
			} else if (location?.state?.type === "Challenges") {
				let hmfObj = {
					"HMF_CHALLENGES": location?.state?.getCourseIds
				}
				dispatch(postCoursesHcfPlan(selectChild?.id, hmfObj))
			}
		}

	}, [selectChild])

	useEffect(() => {
		let planArr = [];
		if (courseshcfData?.records?.length > 0) {
			let planData = courseshcfData?.records[0];
			let planObj = {
				name: planData?.planName,
				id: planData?.planId,
				dimensions: planData?.dimensions,
				duration: 30,
				sittings: 2,
				sequence: 100,
				type: planData?.plantType,
				courseCount: planData?.courseCount,
				lessonCount: planData?.lessonCount,
				perCourseModuleCount: planData?.perCourseModuleCount,
				planObjectives: planData?.planObjectives,
				isRecommendedPlan: true,
				courseModCompletion: planData?.courseModCompletion ? planData?.courseModCompletion : 0
			}
			planArr = [planObj]
			history.replace({ ...history.location, state: {} });
		}
		if (getUserPLanResp?.records?.length > 0) {
			planArr = [...planArr, ...getUserPLanResp?.records];
		}
		// console.log("seacrhText @ : ", seacrhText);

		if (seacrhText && planArr?.length > 0) {
            let myPlanArr = [];
            let getAllMyPlan = [...planArr];
			let searchTextArrBySpace =  seacrhText.split(" ");
			searchTextArrBySpace?.map((myText, myIndex)=>{
				myText && 
				getAllMyPlan?.find((myPlan, planIndex) => {
					let isMyPlan = false;
					// console.log("seacrhText @ searchType @ inSide plan: ",myPlan?.name.toLowerCase().includes(seacrhText.toLowerCase()), searchType === "Plan", !isMyPlan);
					if (myPlan?.name.toLowerCase().includes(myText.toLowerCase()) && !isMyPlan && (!searchType || searchType === "Plan")) {
							isMyPlan = true;
						}
						!isMyPlan && getSequnceSort(myPlan?.dimensions)?.find((dim, index) => {
							
							if (dim?.name.toLowerCase().includes(myText.toLowerCase()) &&  (!searchType || searchType === "Dimension")) {
								isMyPlan = true;
							}
							!isMyPlan && getSequnceSort(dim?.skills)?.find((skill, sKey) => {
								if (skill?.name.toLowerCase().includes(myText.toLowerCase()) &&  (!searchType || searchType === "Skill")) {
									isMyPlan = true;
								}
								!isMyPlan && getSequnceSort(skill?.courses)?.find((course, cKey) => {
									if (course?.name.toLowerCase().includes(myText.toLowerCase()) &&  (!searchType || searchType === "Courses")) {
										// course.isSearch = true;
										isMyPlan = true;
									}
								
							})
						})
					})
					if (isMyPlan && !myPlanArr?.find((item)=>item?.id === myPlan?.id)) {
						myPlanArr.push(myPlan);
					}
				})

			})
           
           planArr = myPlanArr;   
        }

		setAllPlan(planArr);
	}, [getUserPLanResp, courseshcfData, seacrhText])

	// console.log("searchType @ : ", searchType, getAllPlan, searchType === "Plan");


	useEffect(() => {
		if (planIndex !== null) {
			
			if (getAllPlan?.length > 0) {
				let courseObj = getAlluserCourses(getAllPlan[planIndex])[0];
				setSelectedCourse(courseObj);
			}
		}
	}, [getAllPlan, planIndex])

	useEffect(() => {
		if (selectedCourse && planIndex !== null) {
			//	let userId = loggedInUser?.role?.name === "PARENT" ? datesorting(loggedInUser?.children)[0]?.id : selectChild?.id;
			dispatch(getCourseActivityData(selectChild?.id, selectedCourse?.id));
		}
	}, [selectedCourse])

	useEffect(()=>{
		if(getAllPlan?.length > 0 && loggedInUser?.role?.name === "PARENT"){
				let planCourseId = location?.state?.planCourseId;
				let getCourseIndex = -1;
				let tempPlanIndex = -1;
				if(planCourseId){
					getAllPlan?.map((planData, index) => {
						let planCourses = getAlluserCourses(planData);
						if(getCourseIndex === -1 && tempPlanIndex === -1){
							getCourseIndex = planCourses?.findIndex((item)=>item?.id === planCourseId);
							if(getCourseIndex !== -1){
								tempPlanIndex = index;
							}
						}
					})
					if(getCourseIndex !== -1 && tempPlanIndex !== -1){
						setPlanIndex(tempPlanIndex)
						handlePlanGoals(getCourseIndex, tempPlanIndex);
						history.replace({...history.location, state: {}})     
					}
				}
				
			console.log("coursecatlog planCourseId : ",planCourseId ,getCourseIndex, tempPlanIndex, );
		}
	},[getAllPlan])

	console.log("coursecatlog location : ", location, selectedCourse);

	useEffect(()=>{
		if(getAllPlan?.length > 0){
				let planArr = []
				getAllPlan?.map((planData, index) => {
					let coursesArr = [];
					let planCourses = getAlluserCourses(planData);
					
					planCourses?.map((course, index)=>{
						coursesArr.push(...course?.badges);
					})

					let planObj = {...planData, badges: coursesArr};
					planArr.push(planObj);
			})
			setPlanBadgesCurse(planArr);
			console.log("planArr : ", planArr);
		}
	},[getAllPlan])

	useEffect(() => {
		if (selectedCourse && planIndex !== null) {
			//dispatch(getCourseActivityData(selectChild?.id, selectedCourse?.id));
			{/* 
				plan badges show acording to selected course of plan
					let coursesArr = [];
					getAllPlan?.map((planData, index) => {
					if (planIndex !== index) {
						let courseObj = getAlluserCourses(planData)[0];
						coursesArr.push({ ...courseObj, planId: planData?.id });
					} else {
						coursesArr.push({ ...selectedCourse, planId: planData?.id });
					}
				})
			 setPlanBadgesCurse(coursesArr);
				
			*/}
			
			//	console.log("coursesArr : ", selectedCourse, coursesArr,);
			// 	dispatch(getCourseBadges(selectChild?.id, coursesArr))
		}
	}, [selectedCourse])

	// console.log("planBadgesCourse : ", planBadgesCourse);

	const showSelectedCourse = (courseObj) => {
		setSelectedCourse(courseObj);
		setIsViewPlan(true);
	}

	/*
	const handleEnroll = (myplan) => {
		//  console.log("handleEnroll : ", courseObj);
		let getAllPlanCourse = getAlluserCourses(myplan);
		const corkey = getAllPlanCourse?.findIndex((course) => course?.id === selectedCourse?.id)
		getAllPlanCourse[0].courseIndex = corkey;
		getAllPlanCourse[0].childId = selectChild?.id;
		//  getAllPlanCourse[0].planName = myplan?.name;
		if (loggedInUser?.children?.length > 1) {
			dispatch(showModal({ type: "ChildEnrollmentPopUp", course: getAllPlanCourse, }))
		} else {
			dispatch(enrollModal(getAllPlanCourse));
		}
	}
	*/

	const handleEnroll = (myplan) => {
		//  console.log("handleEnroll : ", courseObj);
		let getAllPlanCourse = getAlluserCourses(myplan);
		const corkey = getAllPlanCourse?.findIndex((course) => course?.id === selectedCourse?.id);
		getAllPlanCourse[0].courseIndex = corkey;
		getAllPlanCourse?.map((course, key) => {
			course.childId = selectChild?.id;
			course.sequence = key+1;
		})
		dispatch(enrollModal(getAllPlanCourse));
		// getAllPlanCourse[0].childId = selectChild?.id;
		//  getAllPlanCourse[0].planName = myplan?.name;
		// if (loggedInUser?.children?.length > 1) {
		// 	dispatch(showModal({ type: "ChildEnrollmentPopUp", course: getAllPlanCourse, }))
		// } else {
		// 	dispatch(enrollModal(getAllPlanCourse));
		// }
	}

	const handleEditPlan = (myplan) => {
		dispatch(getPlanSchedule(selectChild?.id, myplan?.id));
		dispatch(selectType("edit"));
		dispatch(enrollModal([]));
	}

	const handlePlanGoals = (courseIndex, getPlanIndex) => {
		let tempPlanIndex =  getPlanIndex ? getPlanIndex : planIndex;
		let myplanData = getAllPlan[tempPlanIndex];
		myplanData.courseIndex = courseIndex ? courseIndex : 0;
		dispatch(showModal({
			type: "PlanGoals", myplanData: myplanData, childData: selectChild
		}));
	}

	const hanldeViewPlan = (myplan) => {
		let getAllPlanCourse = getAlluserCourses(myplan);
		getAllPlanCourse?.map((course, key) => {
			course.childId = selectChild?.id;
			course.sequence = key+1;
		})
		dispatch(selectType("edit"));
		dispatch(enrollModal(getAllPlanCourse));
	}

	const handleChildTab = (childObj) => {
        if (childObj?.isUserPlan) {
            setSelectChild(childObj);
        } else {
            dispatch(showModal({ type: "MyLearnerPlanRedirectPopup" }));
        }
        
    };
	
	return (
		<MainLayOut >
			<div className={`${loggedInUser?.role?.name === "LEARNER" ? "Learner_planscre pt-3 pb-3" : "Parent_planscreen"}`}>
				<div className={`coursecatalogcontainer planpage_  ${loggedInUser?.role?.name === "PARENT" ? "pt-4 pb-4" : "pb-3"}`} >
					<div className="learnertablist  flexone">
						{loggedInUser?.role?.name === "PARENT" && (
							<div className="chilprofiles My_Profile flexone mr-3">
				     <p className="mr-3">Learners:</p>
					 <ul className="flexthree mr-auto">

						{loggedInUser?.children?.length > 0 &&
							datesorting(loggedInUser?.children)?.map((child, index) => (
								<li	className={`text-center ${child?.id === selectChild?.id && "Active_tab"} ${loggedInUser?.children?.length === 1 ? "singlechildtab" : ""} pointer`} onClick={() => handleChildTab(child)}>  
                                    {child.imageUrl ? (<img src={child.imageUrl} alt="childimg"  />
									):(
                                     <span class="user_initials m-0">{getProfileName(child)}</span>
									)}
								    
									{/* {textTrim(getCapitalized(getName(child), 18))} */}
								
								</li>
							))}
					 </ul>
					</div>
						)}
						<div className={`${loggedInUser?.role?.name === "LEARNER" ? "learnersearch w-100" : ""}`}>
						<SearchModule 
							setSearchText={setSearchText}
							seacrhText={seacrhText}
							setSearchType={setSearchType}
							searchType={searchType}
						/>
						</div>
					</div>
				
				</div>
				<div div className="leftpannel">
					{(getAllPlan?.length > 0 || seacrhText) ? (
						<>
							{
								getAllPlan?.length > 0 &&
								getSequnceSort(getAllPlan)?.reverse()?.map((myplan, index) => (
									<div className="myplan_listitems mb-3" key={index}>
										<MyPlanHeader
											myplan={myplan}
											index={index}
											planIndex={planIndex}
											setPlanIndex={setPlanIndex}
											planBadgesCourse={planBadgesCourse} />

										<div className={`LeftpanelContent panel-collapse collapse ${planIndex === index ? "show" : ""}`}
											id={"growthservytbl0" + index}
										>
											<div className="panneltitlesAssets flexone">
												<p className="p2">
													<span>Sessions Per Week: {convertedNumber(myplan?.sittings)} ({myplan?.sittings})</span> <span className="pipe"> | </span>
													<span>Duration Per Session: {myplan?.duration} minutes</span>
												</p>
												{myplan?.isRecommendedPlan ? (
													<p className="p1 pointer" onClick={() => handleEnroll(myplan)}>
														<span className="enroll_link">
															Enroll Now
															<i class="fa-solid fa-arrow-right-long ml-2"></i>
														</span>

													</p>
												) : (
													<p className="p1" onClick={() => handleEditPlan(myplan)}>
														<a href="#">
															<sapn>
																<i class="fa-solid fa-pen mr-1"></i>
																Edit Plan
															</sapn>
														</a></p>

												)}
												{/* <p className="p1" onClick={() => handleEditPlan(myplan)}>
														<a href="#">
															<sapn>
																
																 Upgrade Plan To Unlock More
															</sapn>
														</a></p> */}
											</div>
											<div className="coursecard_list">
												{myplan?.dimensions?.length > 0 &&
													getAlluserCourses(myplan)?.map((course, courseIndex) => (
														<PlanCards
															course={course}
															courseIndex={courseIndex}
															showSelectedCourse={showSelectedCourse}
															selectedCourse={selectedCourse}
															myplan={myplan}
															handlePlanGoals={handlePlanGoals}
															isViewPlan={isViewPlan}
															selectChild={selectChild}
														/>
													))}
											</div>
										</div>
									</div>
								))}
						</>
					) : (
						<ShimmerCategoryList items={4} categoryStyle="STYLE_SEVEN" />
					)}
				</div>
				<MyPlanRightPanel
					selectedCourse={selectedCourse}
					activityArr={courseActivitData?.records}
					myplan={getAllPlan[planIndex]}
					handleEnroll={handleEnroll}
					handlePlanGoals={handlePlanGoals}
					isViewPlan={isViewPlan}
					hanldeViewPlan={hanldeViewPlan}
					setIsViewPlan={setIsViewPlan}
					selectChild={selectChild}
				/>
			</div>
		</MainLayOut>
	);
};

export default MyPlanPage;
